import styled from "styled-components";

export const CheckoutLPContainer = styled.div`
  width: 100%;
  padding-block: 32px;
  padding-inline: 400px;
  flex-wrap: wrap;
  margin: 0px;

  @media screen and (min-width: 1400px) {
    padding-inline: 15%;
    flex-direction: column;
  }

  @media screen and (max-width: 1399px) and (min-width: 1081px) {
    padding-inline: 9%;
    flex-direction: column;
  }

  @media screen and (max-width: 1080px) and (min-width: 800px) {
    padding-inline: 4%;
    flex-direction: column;
  }

  @media screen and (max-width: 799px) and (min-width: 650px) {
    padding-inline: 4%;
    flex-direction: column;
  }

  @media screen and (max-width: 650px) {
    padding-inline: 1px;
    flex-direction: column;
  }
`;

export const Divbackground = styled.div`
  overflow-y: auto;
  height: inherit;
  background: linear-gradient(
    to top,
    ${({ bgColor }) => {
      // recebe bgColor em hexadecimal e converte pra rgb
      const r = parseInt(bgColor.slice(1, 3), 16);
      const g = parseInt(bgColor.slice(3, 5), 16);
      const b = parseInt(bgColor.slice(5, 7), 16);

      // usa o rgb na função rgba pra colocar opacidade
      return `rgba(${r}, ${g}, ${b}, 0.75)`;
    }},
    ${({ bgColor }) => bgColor}
  );
`;

export const CheckoutForm = styled.form`
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-direction: row;

  @media screen and (max-width: 799px) {
    display: block;
    width: 100%;
    padding-inline: 8px;
  }
`;
export const PurchaseCheckout = styled.div`
  display: flex;
  width: 28%;
  flex-direction: column;

  @media screen and (max-width: 799px) {
    display: block;
    width: 100%;
  }
`;

export const CheckoutLPBrasil = styled.article`
  width: 100%;
  justify-content: center;
  display: flex;
  height: 42px;
  background: white;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));

  p {
    margin: 12px 0;
  }
`;

export const CheckoutTestMode = styled.article`
  width: 100%;
  justify-content: center;
  display: flex;
  height: 20px;
  background: red;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));

  p {
    color: white;
    margin-left: 4px;
  }
  .alert {
    display: flex;
    justify-content: center;
  }
`;

export const CheckoutLPFlag = styled.img`
  height: 20px;
  padding-right: 10px;
  margin: 12px 0;
`;

export const InfoContents = styled.div`
  padding: 24px 32px;
  width: 68%;
  background: #ffffff;
  box-shadow: 6.04275px 26.1419px 34.875px rgba(0, 0, 0, 0.04725),
    2.38726px 10.3277px 13px rgba(0, 0, 0, 0.035), 0.522213px 2.25918px 4.625px rgba(0, 0, 0, 0.02275);
  border-radius: 12px;

  h2 {
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 18px;
    margin-bottom: 12px;
    color: #1f2937;
  }

  @media screen and (max-width: 799px) and (min-width: 650px) {
    width: 100%;
    padding-inline: 20px;
  }

  @media screen and (max-width: 650px) {
    width: 100%;
    padding-inline: 14px;
  }

  @media screen and (min-width: 800px) {
    width: 68%;
    flex-direction: row;
  }
`;

export const PurchaseSummary = styled.div`
  top: 10px;
  padding: 24px 24px;
  width: 100%;
  background: #ffffff;
  box-shadow: 6.04275px 26.1419px 34.875px rgba(0, 0, 0, 0.04725),
    2.38726px 10.3277px 13px rgba(0, 0, 0, 0.035), 0.522213px 2.25918px 4.625px rgba(0, 0, 0, 0.02275);
  border-radius: 12px;
  height: fit-content;

  @media screen and (max-width: 799px) {
    width: 100%;
    margin-top: 10px;
    h2 {
      font-size: 20px;
    }
  }

  h2 {
    font-family: "Source Sans Pro";
    font-style: normal;
    font-weight: 600;
  }

  h4 {
    font-family: "Source Sans Pro";
    font-style: normal;
    font-weight: 400;
  }
`;

export const HeaderInfoContents = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;
`;

export const LogoImg = styled.img`
  width: 96px;
  height: 41px;
`;

export const LogoMrImg = styled.img`
  width: 184px;
  height: 70px;
`;

export const DeliveryAddress = styled.div`
  padding: 24px 0px 24px;
  gap: 16px;

  label {
    margin-left: 8px;
  }

  .not_know {
    color: #ff0000;
    font-size: 16px;
  }

  //spans do endereço de entrega
  @media screen and (max-width: 470px) {
    label {
      /* margin-left: 2px; */
    }
  }
`;

export const InputCheckoutLP = styled.input`
  /* font-family: "Source Sans Pro"; */
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 18px;
  color: #545454;
  background: #ffffff;
  border: 1px solid #989898;
  border-radius: 10px;
  height: 46px;
  width: 100%;
  padding-inline: 10px;
  outline: none !important;

  :disabled {
    color: #545454;
    background: #ededed;
  }
`;

//caixas do tipo de entrega
export const DeliveryType = styled.div`
  padding: 24px 0px 24px;
  gap: 16px;
  width: 100%;

  .deliveryTypePrices {
    width: 100%;

    @media screen and (max-width: 362px) {
      margin-left: 50px;
    }

    @media screen and (min-width: 421px) and (max-width: 474px) {
      margin-inline: 15px;
    }

    span {
      background-color: #00629b;
      color: #fff;
      padding-inline: 2px;
      border-radius: 4px;
      font-weight: 700;
      margin-left: 10px;
    }
    input {
      margin-right: 5px;
    }
  }

  @media screen and (max-width: 768px) {
    .deliveryTypePrices {
      div {
        font-size: 15px;
      }
    }
  }
`;

export const DeliveryRadio = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  div {
    width: 50%;
    margin-block: 8px;
    @media screen and (max-width: 1024px) {
      width: 100%;
    }
  }
`;

export const FormPayment = styled.div`
  padding-block: 24px;
  gap: 16px;
`;

export const FormPaymentType = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;

  @media screen and (max-width: 380px) {
    display: block;
    width: 70%;
    margin-inline: 15%;
  }
`;

export const CheckoutTypeFlags = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 47.06px;
  object-fit: contain;
  padding: 4px;
  border: 1px solid rgba(84, 84, 84, 0.7);
  --tw-border-opacity: 0.75;
  border-radius: 8px;
  cursor: pointer;
  background-color: #fdebae;

  &:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(241 245 249 / var(--tw-bg-opacity));
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
  }
`;

export const FlagsContainerRow = styled.div`
  justify-content: space-around;
  margin-inline: 50px;

  @media screen and (max-width: 500px) {
    margin-inline: 20px;
  }
`;

export const FlagsContainer = styled.div`
  margin-left: 4px;
  margin-right: 4px;
  margin-top: 20px;
  width: 105px;

  @media screen and (min-width: 1024px) {
    margin-left: 8px;
    margin-right: 8px;
  }

  @media screen and (min-width: 421px) and (max-width: 700px) {
    width: 30%;
  }
`;

export const ImgFlag = styled.img`
  height: 28px;
`;

export const BoxSelectCheckoutLP = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 10px;
  width: 100%;
`;

export const DivLogoImg = styled.div`
  display: flex;
  width: 100%;
  margin-top: 15px;
  justify-content: center;
  align-items: center;
  padding-inline: 12px;
  padding-top: 12px;
`;

export const SelectCheckoutPayment = styled.select`
  /* border: 1px solid #ddd; */
  outline: none;
  height: 46px;
  width: 100%;
  text-align: center;
  border: 1px solid #989898;
  border-radius: 12px;
  font-weight: 400;
  color: #545454;
  max-width: 450px;
`;

export const SelectCheckoutLP = styled.select`
  border: 1px solid #ddd;
  outline: none;
  height: 46px;
  width: 100%;
  text-align: center;
  border: 1px solid #989898;
  border-radius: 12px;
  font-weight: 400;
  max-width: 450px;

  :disabled {
    color: #545454;
    background: #ededed;
  }
`;

export const SecurityVerification = styled.div`
  padding: 24px 0px 24px;
  gap: 16px;
`;

export const CheckoutAllowTerms = styled.div`
  display: flex;
  align-items: center;

  input {
    margin-right: 10px;
    height: 18px;
    width: 18px;
  }

  a {
    color: var(--color-azul-mrpay);
  }
`;

export const ConfirmBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  transition-timing-function: ease-in-out;
  transition-duration: 0.1s;
  width: 100%;
  padding: 16px 0px;
  text-align: center;
  font-weight: 700;
  box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  border: none;
  font-size: 18px;
  color: ${(props) => (!props.disabled ? props.letterColor : "")};
  background: ${(props) => (props.disabled ? "#F3F3F3" : props.bgColor || "#f1b434")};
  pointer-events: ${(props) => (props.disabled ? "none" : "")};
  cursor: pointer;
`;

export const ProductDescription = styled.div`
  display: flex;

  // Alternar entre hidden e show a descrição do item
  p {
    color: #00629b;
    margin-top: 4px;
    hyphens: auto;
    ${(props) => {
      if (props.reveal) {
        return `overflow-wrap: break-word; overflow: auto;`;
      } else {
        return `white-space: nowrap; overflow: hidden; text-overflow: ellipsis;`;
      }
    }}
    cursor: pointer;
  }
`;

export const BoxProductValues = styled.div`
  border-radius: 12px;
  border: 1px solid #989898;
  padding: 16px 15px;
  margin-bottom: 12px; // provavelmente mudar aqui
  display: flex;
  width: 100%;

  .productsAndPrices {
    width: 100%;
  }

  @media screen and (max-width: 799px) {
    padding: 16px;

    h2 {
      font-size: 20px;
    }
  }

  @media screen and (min-width: 800px) and (max-width: 1024px) {
    padding: 8px;

    h2 {
      font-size: 15px;
    }
  }

  @media screen and (min-width: 1025px) and (max-width: 1120px) {
    padding: 10px;

    h2 {
      font-size: 16px;
    }
  }

  @media screen and (min-width: 1121px) {
    padding: 13px;

    h2 {
      font-size: 18px;
    }
  }
`;

export const TitleProducts = styled.h3`
  margin-bottom: 22px;
`;

export const FormBillingAddress = styled.div`
  margin-bottom: 5px;
  margin-top: 24px;

  .inputCheck {
    margin-right: 4px;
  }

  h2 {
    margin-bottom: 12px;
  }
`;

export const LineDivider = styled.hr`
  background-color: #d9d9d9;
  height: 1px;
  border: none;
`;

export const PurchaseDetails = styled.div`
  margin-top: 30px;
  margin-bottom: 36px;
  .textLine {
    margin-bottom: 12px;
    .textLeft {
      color: #545454;
      font-size: 20px;
      font-weight: 500;
    }
    .textRight {
      font-size: 20px;
      color: #000;
      font-weight: bold;
    }
  }

  .totalTextLine {
    margin-top: 22px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 6px;
    .textLeft {
      color: #545454;
      font-size: 20px;
    }
    .textRight {
      font-size: 20px;
      color: #000;
      font-weight: bold;
    }
  }
`;

export const LoaderStyle = styled.div`
  height: 140px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const InputFormPayment = styled.div`
  min-width: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  object-fit: contain;
  padding: 2%;
  border: 1px solid rgba(84, 84, 84, 0.7);
  --tw-border-opacity: 0.75;
  border-radius: 8px;
  cursor: pointer;
  background-color: #fdebae;
  margin-top: 10px;
  margin-bottom: 20px;

  &:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(241 245 249 / var(--tw-bg-opacity));
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
  }

  @media screen and (max-width: 500px) and (min-width: 380px) {
    padding: 4%;
  }

  @media screen and (max-width: 380px) {
    padding: 6%;
  }
`;

export const PixImg = styled.img`
  width: 180px;
  height: 100px;
`;

export const DivPix = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-block: 20px;

  p {
    align-items: center;
    display: flex;
    text-align: center;
  }
`;

// ------------------------------------------------------

export const Address = styled.div`
  .addressName {
    width: 75%;
  }
  .addressNumber {
    width: 18%;
  }
  .addressComplement {
    width: 100%;
  }
  .addressDistrict {
    width: 40%;
  }
  .addressCity {
    width: 40%;
  }
  .addressState {
    width: 15%;
  }
  .addressCountry {
    width: 25%;
  }
`;

export const CountryCepContainer = styled.div`
  display: flex;
  gap: 8px;

  @media screen and (max-width: 450px) {
    display: block;
    .addressCountry {
      width: 66%;
    }
  }
`;

export const ResponsibleReceiving = styled.div`
  margin-top: 28px;
  width: 100%;
`;

export const ReceiverInformation = styled.div`
  display: flex;
  justify-content: space-between;

  .receiverName {
    width: 58%;
  }
  .receiverPhone {
    width: 35%;
  }

  @media screen and (max-width: 575px) {
    display: block;
    .receiverName {
      width: 100%;
    }
    .receiverPhone {
      width: 100%;
    }
  }
`;

export const Identification = styled.div`
  padding: 24px 0px 24px;

  // Tamanho dos inputs
  .identificationName {
    width: 100%;
  }
  .documentNumber {
    width: 47%;
  }
  .phone {
    width: 47%;
  }
  .email {
    width: 47%;
  }
  .emailConfirm {
    width: 47%;
  }
`;

export const CardContainer = styled.div`
  margin: 24px 0;

  .cardNumber {
    width: 66%;
  }
  .validity {
    width: 33%;
  }
  .cardName {
    width: 50%;
  }
  .securityCode {
    width: 15%;
  }
  .parcelNumber {
    width: 33%;
    position: relative; // responsividade pra selec. das parc.
  }

  /* @media screen and (max-width: 900px) {
    span {
      font-size: 14px;
    }
  } */

  @media screen and (min-width: 700px) and (max-width: 1198px) {
    .cardNumber {
      width: 60%;
    }
    .validity {
      width: 38%;
    }
    .cardName {
      width: 72%;
    }
    .securityCode {
      width: 26%;
    }
    .parcelNumber {
      width: 40%;
      position: relative; // responsividade pra selec. das parc.
    }
  }

  @media screen and (min-width: 421px) and (max-width: 699px) {
    .cardNumber {
      width: 65%;
    }
    .cardName {
      width: 72%;
    }
    .securityCode {
      width: 26%;
    }
    .parcelNumber {
      width: 55%;
      /* position: relative; // responsividade pra selec. das parc. */
    }
  }

  @media screen and (max-width: 420px) {
    .cardNumber {
      width: 58%;
    }
    .validity {
      width: 40%;
    }
    .cardName {
      width: 70%;
    }
    .securityCode {
      width: 28%;
    }
    .parcelNumber {
      width: 70%;
    }
  }
`;

export const CheckoutInformation = styled.div`
  .fieldName {
    margin-top: 8px;
    margin-bottom: 2px;
    margin-left: 8px;

    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
  }

  .centralize {
    text-align: center;
  }

  .inputCardNumber {
    text-align: center;
    font-weight: 500;

    ::placeholder {
      font-size: 14px;
    }
  }

  .inputCardName {
    text-align: center;
    font-size: 15px;
    text-transform: uppercase;

    ::placeholder {
      font-weight: 400;
      font-size: 12px;
    }
  }

  .inputSecurityCode {
    text-align: center;

    ::placeholder {
      font-weight: 400;
      font-size: 14px;
    }
  }

  .internationalState {
    text-align: center;
  }
`;
